import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { dashboardAPI } from "../../../../Api/dashboardAPI";
import { DashboardInitState } from "../../Slices/dashboardSlice";
import { toastError, ToastMessage } from "../../../../utils/toast";

export const getDetalleDeCupo = createAsyncThunk(
  "dashboard/getDetalleDeCupo",
  async (idCupo: number, thunkAPI) => {
    try {
      console.log("getDetalleDeCupo...");
      const response = await dashboardAPI.obtenerDetalleCupo(idCupo);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getDetalleDeCupoBuilder = (
  builder: ActionReducerMapBuilder<DashboardInitState>
) => {
  builder.addCase(getDetalleDeCupo.pending, (state, action) => {
    state.loadingPageScreen = true;
  });
  builder.addCase(getDetalleDeCupo.fulfilled, (state, action) => {
    console.log("getDetalleDeCupo fulfilled :>> ", action);
    state.loadingPageScreen = false;
    const payload = action.payload;
    const esLiberado =
      payload?.es_liberado === true || payload?.es_liberado === "true";
    if (esLiberado) {
      const { disponible_optativo, disponible_obligatorio, ...rest } = payload;
      state.detalleCupo = rest;
    } else {
      state.detalleCupo = payload;
    }
  });
  builder.addCase(getDetalleDeCupo.rejected, (state, action) => {
    console.log("getDetalleDeCupo rejected :>> ", action);
    toastError(ToastMessage.error);
    state.loadingPageScreen = false;
  });
};
